import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const request = async (path, options = {}) => {
  const response = await fetch(`${config.api.url}${path}`, {
    ...options,
    headers: getAuthHeaders(options.headers),
  });
  return handleResponse(response);
};

const clientIntakeApi = {
  fetchCurrentClientIntake: (clientReferenceId) =>
    request(`/clients/${clientReferenceId}/intakes/current`),

  fetchClientIntakeHistory: (clientReferenceId) =>
    request(`/clients/${clientReferenceId}/intakes`),

  startClientIntakeUpdate: (clientReferenceId, intakeReferenceId) =>
    request(`/clients/${clientReferenceId}/intakes/${intakeReferenceId}/update`, { method: 'POST' }),

  saveClientIntakeDraft: (clientReferenceId, intakeReferenceId, responses, expectedSaveVersion) =>
    request(`/clients/${clientReferenceId}/intakes/${intakeReferenceId}/draft`, {
      method: 'PUT',
      body: JSON.stringify({
        responses,
        expectedSaveVersion: expectedSaveVersion === undefined || expectedSaveVersion === null
          ? 0
          : Number(expectedSaveVersion),
      }),
    }),

  completeClientIntake: (clientReferenceId, intakeReferenceId, responses, expectedSaveVersion) =>
    request(`/clients/${clientReferenceId}/intakes/${intakeReferenceId}/complete`, {
      method: 'POST',
      body: JSON.stringify({
        responses,
        expectedSaveVersion: expectedSaveVersion === undefined || expectedSaveVersion === null
          ? 0
          : Number(expectedSaveVersion),
      }),
    }),

  changeClientType: (clientReferenceId, clientType) =>
    request(`/clients/${clientReferenceId}/client-type`, {
      method: 'PUT',
      body: JSON.stringify({ clientType }),
    }),

  linkClientIntakeBaby: (clientReferenceId, intakeReferenceId, babyReferenceId) =>
    request(`/clients/${clientReferenceId}/intakes/${intakeReferenceId}/link-baby`, {
      method: 'POST',
      body: JSON.stringify({ babyReferenceId }),
    }),

  createClientIntakePregnancyBaby: (clientReferenceId, intakeReferenceId, payload) =>
    request(`/clients/${clientReferenceId}/intakes/${intakeReferenceId}/create-pregnancy-baby`, {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};

export default clientIntakeApi;
